// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__OZlil","vLegacy":"SelectSecondary_vLegacy__j8-uX","error":"SelectSecondary_error__2gds7","disabled":"SelectSecondary_disabled__3po8-"};